module.exports = __webpack_public_path__ + "img/clear-the-clutter.0040bf35.png";